import { TableV2 } from '@anytag/shared-atoms';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { FacebookPageAnalyticsPostsPayload } from '@anytag/graphql';
import { InfluencerFacebookAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { useInfluencerFacebookPostsListTable } from './hooks';

export interface InfluencerFacebookPostsListProps extends TableData<FacebookPageAnalyticsPostsPayload> {
  influencerId?: number;
  mainSocialAccountId?: number;
}

export const InfluencerFacebookPostsList = ({
  loading,
  data = [],
  influencerId,
  mainSocialAccountId
}: InfluencerFacebookPostsListProps) => {
  const { columns } = useInfluencerFacebookPostsListTable();

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} rowHeight="62px" noTopBorderRadius hasBorder />

      <InfluencerFacebookAnalyticsPostDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), influencerId, mainSocialAccountId }))}
      />
    </>
  );
};
